export var BasicDataset;
(function (BasicDataset) {
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["Model"] = "model";
        TypeEnum["Observation"] = "observation";
        TypeEnum["Product"] = "product";
    })(TypeEnum = BasicDataset.TypeEnum || (BasicDataset.TypeEnum = {}));
    let TemporalNatureEnum;
    (function (TemporalNatureEnum) {
        TemporalNatureEnum["Hindcast"] = "hindcast";
        TemporalNatureEnum["Forecast"] = "forecast";
        TemporalNatureEnum["Nowcast"] = "nowcast";
        TemporalNatureEnum["Realtime"] = "realtime";
        TemporalNatureEnum["Static"] = "static";
    })(TemporalNatureEnum = BasicDataset.TemporalNatureEnum || (BasicDataset.TemporalNatureEnum = {}));
    let DataTypeEnum;
    (function (DataTypeEnum) {
        DataTypeEnum["Grid"] = "grid";
        DataTypeEnum["Spectrum"] = "spectrum";
        DataTypeEnum["Scatter"] = "scatter";
        DataTypeEnum["Constituents"] = "constituents";
        DataTypeEnum["Point"] = "point";
        DataTypeEnum["Document"] = "document";
    })(DataTypeEnum = BasicDataset.DataTypeEnum || (BasicDataset.DataTypeEnum = {}));
})(BasicDataset || (BasicDataset = {}));
